export default __webpack_public_path__ + "static/media/animation-header.daa3cf2c.gif";